import BackedEnum from '@/enums/BackedEnum';

export default class Designation extends BackedEnum {}

Designation.Veterinarian = 'VET';
Designation.Technician = 'TECH';
